import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import * as configActions from "./config.actions";
import {catchError, map, switchMap, throwError} from "rxjs";
import {AccessControlService} from "../../services/access-control.service";
import {ConfigI} from "../../interfaces/config.interface";

@Injectable()
export class ConfigEffects {

  loadConfig$ = createEffect(() =>
    this.actions$.pipe(
      ofType(configActions.loadConfig),
      switchMap((action) => {
        // Show splash
        this.store.dispatch(configActions.setLoadingConfig({status: true}));

        // Load data from access control
        // todo: Modify for mango core service when ready using module_pk and module_sk
        return this.accessControlService.getConfigData({
          url: action.url,
          random_pass: action.secret
        }).pipe(
          map((response: ConfigI) => {
            this.store.dispatch(configActions.setLoadingConfig({status: false}));
            return configActions.loadConfigSuccess({ config: response });
          }),
          catchError((error) => {
            console.log(new Date(), "ERROR:", error);
            this.store.dispatch(configActions.setLoadingConfig({status: false}))
            if (error.status == 400) {
              this.notification.error(error.error, "Process not Found")
            }
            return throwError(error);
          })
        );
      })
    )
  );

	constructor(
		private actions$: Actions,
		private store: Store,
    private router: Router,
    private route: ActivatedRoute,
    private notification: ToastrService,
    private accessControlService: AccessControlService
	) {}
}
